import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getPopup, updatePopup } from "../../../api/popup.api";
import ErrorResponse from "../../../components/ErrorResponse";
import PopupEditor from "../../../components/homepage/popup/Editor";
import Header from "../../../components/layout/Header";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetPopup } from "../../../models/popup.model";

interface IMatch {
  campusCode: string;
  popupCode: string;
}

const PopupEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const campusCode = match.params.campusCode;
  const popupCode = Number(match.params.popupCode);
  const history = useHistory();
  const location = useLocation();

  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetPopup>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (campusCode && popupCode) {
      execute(getPopup(campusCode, popupCode));
    }
  }, [campusCode, popupCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/homepage/popup${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    if (!campusCode || !popupCode) return;
    submitExecute(updatePopup(campusCode, popupCode, data));
  }

  return (
    <div className="content-wrapper">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <Header
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.popup.title4')}
      />
      <PopupEditor
        data={res?.data}
        submit={submit}
      />
    </div>
  );
}

export default PopupEdit;
